import type { Activity } from '@/features/client-portal/hooks/use-document-approval'
import type { DocumentApprovalFlowResponse } from '@/features/negotiations/hooks/use-document-approval-flows'
import { axiosPrivate } from '@/shared/api/axios'

import { API } from '@/shared/constants/api'

export const getFlowsByNegotiation = async (
  negotiationId: string
): Promise<DocumentApprovalFlowResponse[]> => {
  const response = await axiosPrivate.get<DocumentApprovalFlowResponse[]>(
    `${API.approvalFlows.root}/negotiation/${negotiationId}`
  )
  return response.data
}

export const getFlowActivities = async (flowId: string): Promise<Activity[]> => {
  const response = await axiosPrivate.get<Activity[]>(
    `${API.approvalFlows.root}/${flowId}/activities`
  )
  return response.data
}
